module.exports = __webpack_public_path__ + "static/media/boxing-glove.d0638100.svg";